import { render, staticRenderFns } from "./pro-baseinfo.vue?vue&type=template&id=246b3af8&scoped=true"
import script from "./pro-baseinfo.vue?vue&type=script&lang=js"
export * from "./pro-baseinfo.vue?vue&type=script&lang=js"
import style0 from "./pro-baseinfo.vue?vue&type=style&index=0&id=246b3af8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b3af8",
  null
  
)

export default component.exports